module.exports = __webpack_public_path__ + "static/assets/6ad08dfbab9788533db0e602a333d1d7.svg";